import React from 'react';

import IntelligenceDateControls from './intelligenceDateControls'
import IntellegenceResultWrapper from './intellegenceResultWrapper'
import ContentInner from '../../../shared/contentInner'

import styles from './carsIntellegence.module.scss'

const CarsIntellegence = () => {
  return (
    <div className={styles.carsIntellegence}>
      <IntelligenceDateControls />

      <ContentInner>
        <IntellegenceResultWrapper />
      </ContentInner>
    </div>
  )
}

export default React.memo(CarsIntellegence)